import React from 'react'
import { Grid } from '@material-ui/core'
import PageLayout from '../../common/PageLayout'
import PageHeading from '../../common/PageHeading'
import Divider from '../../../../../components/atoms/Divider'
import FlexRow from '../../../../../components/molecules/FlexRow'
import FadeIn from '../../../../../components/molecules/Transitions/FadeIn'
import UsageBarChart from './UsageBarChart'

function UsageHome () {
  return (
    <PageLayout className='font-serif' variant='constrained'>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <PageHeading title='Denali AI Usage' />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <FlexRow className='font-size-md'>
            <p>
              Track your AI usage patterns and token consumption over time. Monitor AI invocations
              to understand how Denali AI is being utilized across your organization.
            </p>
          </FlexRow>
        </Grid>
        <Grid item xs={12}>
          <FadeIn delay={0.1} duration={1}>
            <UsageBarChart />
          </FadeIn>
        </Grid>
      </Grid>
    </PageLayout>
  )
}

export default UsageHome
